<nz-calendar>
  <ul *nzDateCell="let date" class="events">
    <ng-container *ngIf="getDateEvents(date) as events">
      <ng-container *ngFor="let event of events">
        <li>
          <span nz-tooltip [nzTooltipTitle]="event.content">
            <nz-badge [nzStatus]="event.type" [nzText]="event.content"></nz-badge>
          </span>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</nz-calendar>
